import React from "react";
import CTA from "./CTA";
import HeaderSocials from "./HeaderSocials";
import Typewriter from "typewriter-effect";
import "./header.css";

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Vishal Kumar</h1>
        <h5 className="text-light">
          <Typewriter
            options={{
              strings: ["CS Student", "Programmer", "Web Developer"],
              autoStart: true,
              loop: true,
            }}
          />
        </h5>
        <CTA />
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
        <HeaderSocials />
      </div>
    </header>
  );
};

export default Header;
